module.exports = __webpack_public_path__ + "img/LoaderNotify.928097a.svg";